import React, { useState } from 'react';
import { useService } from '@Client/runner.hooks/useService';
import { SharedAngular } from '@Client/@types/sharedAngular';
import CustomTabs, {
  ICustomTab
} from '@Shared.Angular/flowingly.components/CustomTabs/CustomTabs';
import WorkflowReportsTab from './Tabs/WorkflowReportsTab';
import ProcessMapReportsTab from './Tabs/ProcessMapReportsTab';
import UserReportsTab from './Tabs/UserReportsTab';
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import CustomTabPanel from '@Shared.Angular/flowingly.components/CustomTabs/CustomTab/CustomTabPanel';

const Reports = () => {
  const APP_CONFIG = useService<SharedAngular.APP_CONFIG>('APP_CONFIG');
  const permissionsService =
    useService<SharedAngular.PermissionsService>('permissionsService');

  const tabs: ICustomTab[] = [
    {
      key: 'workflows',
      label: 'Workflows',
      isDisabled: false,
      isHidden: !APP_CONFIG.allowWorkflow
    },
    {
      key: 'processmaps',
      label: 'Process Maps',
      isDisabled: false,
      isHidden:
        !permissionsService.currentUserHasPermission(
          FlowinglyPermissions.LIBRARY_ACCESS
        ) || !APP_CONFIG.allowProcessMap
    },
    {
      key: 'users',
      label: 'Users',
      isDisabled: false,
      isHidden: !permissionsService.currentUserHasPermission(
        FlowinglyPermissions.SETUP_USER_ACCESS
      )
    }
  ];

  const [selectedTabIndex, setSelectedTabIndex] = useState(
    tabs.findIndex((tab) => !tab.isHidden)
  );

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newIndex: React.SetStateAction<number>
  ) => {
    setSelectedTabIndex(newIndex);
  };

  return (
    <div id="reports-page" className="runner-page">
      <CustomTabs
        selectedTabIndex={selectedTabIndex}
        onChange={handleTabChange}
        tabs={tabs}
        fitContent={true}
      ></CustomTabs>
      <CustomTabPanel index={0} value={selectedTabIndex}>
        <WorkflowReportsTab />
      </CustomTabPanel>
      <CustomTabPanel index={1} value={selectedTabIndex}>
        <ProcessMapReportsTab />
      </CustomTabPanel>
      <CustomTabPanel index={2} value={selectedTabIndex}>
        <UserReportsTab />
      </CustomTabPanel>
    </div>
  );
};

export default Reports;
